module.exports = __webpack_public_path__ + "media/images/elionline/icons/send_invite-57d028993bc27888145e4f252d29b2c6.svg";